// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ITYzr","colBig":"styles_colBig__3hvyj","colSmall":"styles_colSmall__23uKL"};